var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7659_64973)",
    fill: "#02BD9C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2 12.472V8.9c0-1.048-.864-1.9-1.928-1.9h-.108V5.9c0-1.048-.864-1.9-1.928-1.9h-1.992l-.092-.16L15.396.724a1.403 1.403 0 00-.872-.672 1.36 1.36 0 00-1.056.152L7.04 4.008H1.928A1.907 1.907 0 00.036 5.56.425.425 0 000 5.72v15.548C0 22.332.864 23.2 1.928 23.2h19.344a1.932 1.932 0 001.928-1.932v-3.34c.464-.164.8-.604.8-1.128v-3.2c0-.52-.336-.96-.8-1.128zM19.236 4.8c.624 0 1.128.492 1.128 1.1V7h-1.432l-1.24-2.2h1.544zm-2.576-.208L18.016 7h-5.428l4.068-2.408h.004zM13.88.884a.577.577 0 01.444-.064.6.6 0 01.376.292l.56.996L6.996 7H3.54L13.876.884h.004zM1.928 4.8h3.76L2.164 6.884A.966.966 0 001.996 7h-.064A1.119 1.119 0 01.804 5.9c0-.608.508-1.1 1.128-1.1h-.004zm19.344 17.6H1.928C1.308 22.4.8 21.892.8 21.268V7.432a1.92 1.92 0 001.128.368h19.344c.62 0 1.128.492 1.128 1.1v3.5H18c-.752 0-1.456.292-1.976.82a2.757 2.757 0 00-.824 1.98c0 1.544 1.256 2.8 2.8 2.8h4.4v3.268c0 .624-.508 1.132-1.128 1.132zm1.928-5.6c0 .22-.18.4-.4.4H18a2 2 0 010-4h4.8c.22 0 .4.18.4.4v3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16.4a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7659_64973"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v23.2H0z"
  })))));
}
SvgWallet.displayName = 'Wallet';
export default SvgWallet;